import React from "react";
import { Box, Typography } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DoNotDisturbOnOutlinedIcon from "@mui/icons-material/DoNotDisturbOnOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export const CARD_TONE = {
  paywallViewed: { color: "#2E80DB", Icon: VisibilityOutlinedIcon },
  uniqueUsers: { color: "#6E59D9", Icon: PeopleOutlineIcon },
  purchaseStarted: { color: "#C77700", Icon: ShoppingBagOutlinedIcon },
  successfulPayment: { color: "#008E40", Icon: CheckCircleOutlineIcon },
  cancelledPayment: { color: "#E8710A", Icon: DoNotDisturbOnOutlinedIcon },
  failedPayment: { color: "#D93025", Icon: ErrorOutlineIcon },
};

export const cardSx = (isActive) => ({
  all: "unset",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  gap: 1.25,
  p: 2,
  minWidth: 0,
  borderRadius: "14px",
  bgcolor: isActive ? "#FFF8F7" : "#fff",
  border: `1px solid ${isActive ? "#BE1F1F" : "#ECECEC"}`,
  boxShadow: isActive ? "0 0 0 3px rgba(190,31,31,0.08)" : "0 1px 2px rgba(16,24,40,0.04)",
  transition: "border-color .15s, box-shadow .15s",
});

const TrendChip = ({ change, isPositive }) => {
  if (!change) {
    return <Box component="span" sx={{ px: 0.75, py: "1px", borderRadius: "6px", fontSize: 12, fontWeight: 600, color: "#5F6368", bgcolor: "#F1F3F4" }}>0%</Box>;
  }
  const tone = isPositive ? "#008E40" : "#D93025";
  const Arrow = change > 0 ? ArrowUpwardIcon : ArrowDownwardIcon;
  return (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.25, px: 0.75, py: "1px", borderRadius: "6px", fontSize: 12, fontWeight: 600, color: tone, bgcolor: `${tone}14` }}>
      <Arrow sx={{ fontSize: 13 }} />
      {Math.abs(change).toLocaleString(undefined, { maximumFractionDigits: 1 })}%
    </Box>
  );
};

const StatsCardPayment = ({ iconKey, title, value, change, isPositive, subtitleRight, isActive, onClick }) => {
  const { color, Icon } = CARD_TONE[iconKey] || CARD_TONE.paywallViewed;
  return (
    <Box
      component="button"
      type="button"
      aria-pressed={isActive}
      onClick={onClick}
      sx={{
        ...cardSx(isActive),
        cursor: "pointer",
        "&:hover": { borderColor: isActive ? "#BE1F1F" : "#D6D6D6", boxShadow: isActive ? undefined : "0 4px 12px rgba(16,24,40,0.06)" },
        "&:focus-visible": { outline: "2px solid #BE1F1F", outlineOffset: 2 },
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Box sx={{ width: 32, height: 32, flexShrink: 0, borderRadius: "8px", bgcolor: `${color}14`, color, display: "grid", placeItems: "center" }}>
          <Icon sx={{ fontSize: 18 }} />
        </Box>
        <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#3C4043" }} noWrap>{title}</Typography>
      </Box>

      <Typography sx={{ fontSize: 28, fontWeight: 700, color: "#111", lineHeight: 1.1 }}>{value}</Typography>

      <Box display="flex" alignItems="center" gap={0.75} flexWrap="wrap">
        <TrendChip change={change} isPositive={isPositive} />
        <Typography sx={{ fontSize: 12, color: "#9AA0A6" }}>vs previous period</Typography>
      </Box>

      <Typography sx={{ fontSize: 12, color: "#5F6368", borderTop: "1px dashed #ECECEC", pt: 1.25, mt: "auto" }}>
        {subtitleRight || " "}
      </Typography>
    </Box>
  );
};

export default StatsCardPayment;
